function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 52.5,
  cy: 52.5,
  r: 52.5,
  fill: "#0085FF",
  fillOpacity: 0.08
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#activity-log-empty-state_svg__filter0_d_774_5712)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 28,
  width: 130,
  height: 50,
  rx: 2,
  fill: "#fff"
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 29,
  y: 53,
  width: 36,
  height: 16,
  rx: 2,
  fill: "#0085FF"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M31.057 55h31v5h-31zM31.057 62h21v5h-21z"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 68,
  y: 53,
  width: 36,
  height: 16,
  rx: 2,
  fill: "#0085FF"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M70.057 55h31v5h-31zM70.057 62h21v5h-21z"
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 68,
  y: 34,
  width: 36,
  height: 16,
  rx: 2,
  fill: "#B39DDB"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M70 36h31v5H70zM70 43h21v5H70z"
});
var _ref9 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 107,
  y: 34,
  width: 36,
  height: 16,
  rx: 2,
  fill: "#B39DDB"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M109 36h31v5h-31zM109 43h21v5h-21z"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  fill: "#0085FF",
  d: "M29 34h2v6.428h-2zM29 41.857h2V44h-2z"
});
var _ref10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "activity-log-empty-state_svg__filter0_d_774_5712",
  x: 13,
  y: 22,
  width: 146,
  height: 66,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_774_5712"
}), /*#__PURE__*/React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow_774_5712",
  result: "shape"
})));
function SvgActivityLogEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 105,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10);
}
export default SvgActivityLogEmptyState;